import { z } from 'zod';
import { templateBaseSchema } from './base';
import {
  templateFontSizeSchema,
  templateTextAlignSchema,
  templateTextColorSchema,
  templateTextFormatSchema,
} from './typography';

export const templateHeadingSchema = templateBaseSchema.extend({
  type: z.enum(['heading1', 'heading2', 'heading3']),
  content: z.string(),
  align: templateTextAlignSchema,
  indent: z.number().int().nonnegative(),
  color: templateTextColorSchema,
  textFormat: z.array(templateTextFormatSchema),
  fontSize: templateFontSizeSchema,
});

export type TemplateHeadingV1 = z.infer<typeof templateHeadingSchema>;
